<template>
<div>

  <el-row>
    <el-col :span="17">
  <!-- 面包屑导航区域-->
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
    <el-breadcrumb-item>Setup</el-breadcrumb-item>
    <el-breadcrumb-item>Business Partner</el-breadcrumb-item>
  </el-breadcrumb>
</el-col>
  <!-- <el-col class="el-breadcrumb__inner" font-size="3px" :span="6">
    Updating Time: {{ this.updateTime }}
    </el-col> -->
  </el-row>
  <!--卡片视图区域-->

  <el-card>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="Customer Code:">
        <el-input v-model="formInline.code" placeholder="Customer Code" clearable></el-input>
      </el-form-item>
      <el-form-item >
        <el-button type="primary" @click="onSubmit">Search</el-button>
        </el-form-item>
        <el-form-item>
        <el-button type="primary" @click="customerDialogOpen">Add</el-button>
       </el-form-item>
    </el-form>
    <el-dialog title="Business Partner"
      width="50%" :visible.sync="dialogFormVisible" @close="editDialogClosed">
      <el-form :model="customerOpenform" label-width="200px" :rules="editFormRules" ref="customerOpenform">
          <el-form-item label="BP Code:" prop="customer.code">
            <el-input v-model="customerOpenform.customer.code" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item label="BP Name:" prop="customer.name">
              <el-input v-model="customerOpenform.customer.name" style="width: 300px"></el-input>
              </el-form-item>
              <el-form-item label="Short Desc.:">
                <el-input v-model="customerOpenform.customer.shortDesc" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="BP Type:">
                  <el-select v-model="customerOpenform.customer.type" style="width: 300px">
                      <el-option
                        v-for="item in bpTypes"
                        :key="item"
                        :label="item"
                        :value="item">
                      </el-option>
                    </el-select>
                </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">Cancel</el-button>
            <el-button type="primary" @click="customerDialogSave('customerOpenform')">Save</el-button>
          </div>
          </el-dialog>

      <!-- CRProject 列表区域 -->
      <el-table :data="customerList" border stripe style="width: 100%">
        <el-table-column type="index" label="#"></el-table-column>
            <el-table-column
              prop="code"
              label="Code"         sortable
              width="120">
            </el-table-column>
            <el-table-column
              prop="name"      sortable
              label="Name"
              width="290">
            </el-table-column>
            <el-table-column
              prop="shortDesc"      sortable
              label="Short Desc."
              width="250">
            </el-table-column>
            <el-table-column
              prop="type"      sortable
              label="Customer Type"
              width="180">
            </el-table-column>
            <el-table-column
              label="Operation"
              width="350">
              <template slot-scope="props">
                <!-- <el-button type="info" plain size="mini" @click="view(props.row.id)">View</el-button> -->
                <el-button type="info" plain size="mini" @click="edit(props.row.code)">Edit</el-button>
                <el-button type="info" plain size="mini" @click="del(props.row.code)">Delete</el-button>
                </template>
            </el-table-column>

          </el-table>

          <!-- 分页区域-->
           <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="formInline.page"
                :page-sizes="[10, 20, 30, 50, 100, total]"
                :page-size="formInline.rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
  </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formInline: {
        code: '',
        token: '',
        page: 1,
        rows: 100
      },
      userName: '',
      brandParam: {
        userName: '',
        userType: ''
      },
      customerOpenform: {
        customer: {
          id: -1,
          code: '',
          name: '',
          shortDesc: '',
          type: 'Customer'
        }
      },
      total: 0,
      operation: '',
      customerList: [],
      bpTypes: ['Customer', 'Prospect', 'Supplier', 'Partner'],
      dialogFormVisible: false,
      editFormRules: {
        customer: {
          code: [
            { required: true, trigger: 'blur', message: 'Required' }
          ],
          name: [
            { required: true, trigger: 'blur', message: 'Required' }
          ]
        }
      }
    }
  },
  created () {
    this.userName = window.sessionStorage.getItem('username')
    this.formInline.token = window.sessionStorage.getItem('token')
    this.brandParam.userName = this.userName
    this.brandParam.userType = window.sessionStorage.getItem('userType')
    this.getCustomers()
  },
  methods: {
    onSubmit () {
      console.log('submit!')
      this.formInline.page = 1
      this.getCustomers()
    },
    async customerDialogOpen () {
      this.customerOpenform.customer = { id: -1, code: '', name: '' }
      // this.operation = 'add'

      this.dialogFormVisible = true
    },
    async edit (value) {
      this.operation = 'edit'
      this.dialogFormVisible = true

      const { data: res } = await this.$http.get('/customerBrand/getCustomer', { params: { value: value } })

      this.customerOpenform.customer = res.customer
      console.log('res.customer === ' + res.customer.code)
    },
    async view (value) {
      this.operation = 'view'
      this.dialogFormVisible = true
    },
    async customerDialogSave (formName) {
      var flag = false
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log('已提交表单')
          flag = true
          // const { data: res } = this.$http.post('/customerBrand/customerSave', { params: this.customerOpenform })
          // setTimeout(() => {
          //   console.log('res.errMsg ===' + res.errMsg + '111')
          //   if (res.errMsg !== '') {
          //     this.$alert('Warning', '1111111')
          //   } else {
          //     this.dialogFormVisible = false
          //     this.$message.success('1111111111111111')
          //     this.getCustomers()
          //   }
          // }, 900)
        } else {
          console.log('error submit!!')
          return false
        }
      })
      if (flag === true) {
        const { data: res } = await this.$http.post('/customerBrand/customerSave', { params: this.customerOpenform })
        setTimeout(() => {
          console.log('res.errMsg ===' + res.errMsg + '111')
          if (res.errMsg !== '') {
            this.$alert('Code already exists!', 'Warning')
          } else {
            this.dialogFormVisible = false
            this.$message.success('Update Successfully!')
            this.getCustomers()
          }
        }, 200)
      }
    },
    editDialogClosed () {
      this.$refs.customerOpenform.resetFields()
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    // exportToExcel () {
    //   /* 表示在当前页面打开新地址 */
    //   window.open('http://51.68.206.7:8081/show/exportMoq?token=' + encodeURIComponent(this.formInline.token) + '&brand=' + this.formInline.brands + '&product=' + this.formInline.product, '_parent')
    // },
    async getCustomers () {
      const { data: res } = await this.$http.get('/customerBrand/customerList', { params: this.formInline })
      this.customerList = res.rows
      this.total = res.total
    },
    async del (value) {
      const that = this
      this.$confirm('This will permanently delete the Project. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        await that.confirmDelete(value)
        // this.$message({
        //   type: 'success',
        //   message: 'Delete completed!'
        // })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: 'Delete canceled'
        // })
      })
    },
    confirmDelete (value) {
      // Vue.prototype.$http = axios
      const that = this
      this.$http.get('/customerBrand/deleteCustomer', { params: { value: value } })
        .then(res => {
          that.getCustomers()
          that.$message({
            message: '删除成功',
            type: 'success',
            duration: 500
          })
        })
        .catch(error => {
          console.log(error)
          that.$message({
            message: '删除失败',
            type: 'error'
          })
        })
    },
    /* prospectFormat (row, column, cellValue, index) {
      const daterc = row[column.property]
      if (daterc === null || daterc === '') {
        return
      }
      if (daterc === 'P') {
        return 'Prospect'
      } else {
        return 'Customer'
      }
    }, */
    dateFormat (row, column, cellValue, index) {
      const daterc = row[column.property]
      if (daterc === null || daterc === '' || daterc === '1753/01/01 00:00:00') {
        return
      }
      var date = new Date(daterc) // long转换成date
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      // if (month < 10) {
      //   month = '0' + month
      // }
      var monthLetterArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      var monthLetter = monthLetterArr[parseInt(month) - 1]
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + monthLetter + '-' + day
    },
    nullFormatBlank (row, column, cellValue, index) {
      const daterc = row[column.property]
      // console.log('daterc111===' + daterc)
      if (daterc === 'null' || daterc === null) {
        return ''
      }
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.formInline.rows = val
      this.getCustomers()
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.formInline.page = val
      this.getCustomers()
    }
  }
}
</script>

<style lang="less" scoped="scoped">
  .div-class1 {
    border:solid 1px #000;
    margin-bottom: 15px;
    padding-top:10px;
    // line-height: 50px;
  }
  .div-class {
    border:solid 1px #000;
  }
  .div-class2 {
    border:solid 1px #000;
    padding: 10px;
  }
  .div-project-class {
    border:solid 1px #000;
    padding: 10px;
  }
  .div-title-class {
    border-top:solid 1px #000;
    border-left:solid 1px #000;
    border-right:solid 1px #000;
    color: white;
    text-align: left;
    background-color: rgba(156, 156, 156);
  }
  .div-titlefin-class {
    border-top:solid 1px #000;
    border-left:solid 1px #000;
    border-right:solid 1px #000;
    color: white;
    margin-top:5px;
    background-color: rgba(156, 156, 156);
    text-align: left;
  }
  .dialogTitle{
    text-align: center;
  }

</style>
